module.exports = __webpack_public_path__ + "static/media/blue-cross.0d280a25.svg";